export default __webpack_public_path__ + "static/media/logo.fc8355c0.svg";